import { useCallback, useRef, useState } from "react"
import type { MyBrandCreativeCardModel } from "../lib/drilldown-card.types"

const CACHE_SIZE = 5

function preloadCreativeMedia(model: MyBrandCreativeCardModel): void {
  const urls = [model.thumbnailUrl, model.isVideo ? "" : model.assetUrl].filter(Boolean)
  for (const url of urls) {
    const img = new Image()
    img.src = url
  }
}

export function useDrilldownMyBrandCreativeCache() {
  const cacheRef = useRef<Map<string, MyBrandCreativeCardModel>>(new Map())
  const [, bump] = useState(0)

  const put = useCallback((model: MyBrandCreativeCardModel) => {
    const next = new Map(cacheRef.current)
    next.delete(model.id)
    next.set(model.id, model)
    while (next.size > CACHE_SIZE) {
      const oldest = next.keys().next().value
      if (oldest) next.delete(oldest)
    }
    cacheRef.current = next
    preloadCreativeMedia(model)
    bump((v) => v + 1)
  }, [])

  const get = useCallback((id: string) => cacheRef.current.get(id), [])

  return { put, get }
}
